import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import type { SelectChangeEvent } from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import type { ChangeEvent } from "react";
import type { GetWebhookLogListArgs } from "@/api/webhook-log/getWebhookLogList";

interface WebhookLogListFiltersProps {
  filters: GetWebhookLogListArgs;
  onChange: (filters: GetWebhookLogListArgs) => void;
}

const SOURCES = ["CIN7", "SHOPIFY"];
const OUTCOMES = ["handled", "unhandled", "failed", "rejected"];

/** Source, outcome and event filters for the webhook log; "" means "any". */
export const WebhookLogListFilters = (props: WebhookLogListFiltersProps) => {
  const { filters, onChange } = props;

  const handleSourceChange = (event: SelectChangeEvent) => {
    onChange({ ...filters, source: event.target.value });
  };

  const handleOutcomeChange = (event: SelectChangeEvent) => {
    onChange({ ...filters, outcome: event.target.value });
  };

  const handleEventChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...filters, event: event.target.value });
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ mb: 2 }}
    >
      <FormControl
        size="small"
        sx={{ minWidth: 140 }}
      >
        <InputLabel id="webhook-log-source">Source</InputLabel>
        <Select
          label="Source"
          labelId="webhook-log-source"
          onChange={handleSourceChange}
          value={filters.source ?? ""}
        >
          <MenuItem value="">Any</MenuItem>
          {SOURCES.map((source) => (
            <MenuItem
              key={source}
              value={source}
            >
              {source}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        size="small"
        sx={{ minWidth: 140 }}
      >
        <InputLabel id="webhook-log-outcome">Outcome</InputLabel>
        <Select
          label="Outcome"
          labelId="webhook-log-outcome"
          onChange={handleOutcomeChange}
          value={filters.outcome ?? ""}
        >
          <MenuItem value="">Any</MenuItem>
          {OUTCOMES.map((outcome) => (
            <MenuItem
              key={outcome}
              value={outcome}
            >
              {outcome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Event (exact, e.g. Sale/PickAuthorised)"
        onChange={handleEventChange}
        size="small"
        sx={{ minWidth: 320 }}
        value={filters.event ?? ""}
      />
    </Stack>
  );
};
